import { NetworkPillNetworks } from '@frontend/ui-library';
import { ApiChainSymbolKeys } from './enums';

export function networkPillMap(network: ApiChainSymbolKeys) {
  const networkMap: Record<ApiChainSymbolKeys, NetworkPillNetworks> = {
    'LN-BTC': 'ln-btc',
    BTC: 'btc',
    ETH: 'eth',
    MATIC: 'polygon',
    POLYGON: 'polygon',
    ERD: 'erd',
    DASH: 'dash',
    TRX: 'trx',
    BinancePay: 'binancePay',
    SOL: 'solanaPay',
    SUI: 'sui',
    HEDERA: 'hedera',
  };

  return networkMap[network];
}
